// material-ui
import { Box, Button, Grid, Stack, Typography } from '@mui/material';

// assets
import error404 from 'assets/images/maintenance/error.png';

// ==============================|| ERROR 404 - MAIN ||============================== //

function ErrorState() {
  return (
    <>
      <Grid
        container
        spacing={10}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh', pt: 1.5, pb: 1, overflow: 'hidden' }}
      >
        <Grid item xs={12}>
          <Stack direction="row">
            <Grid item>
              <Box sx={{ width: { xs: 250, sm: 590 } }}>
                <img src={error404} alt="mantis" style={{ width: '100%', height: '100%' }} />
              </Box>
            </Grid>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Typography variant="h1" align="center">
              Something went wrong
            </Typography>
            <Typography color="textSecondary" align="center" sx={{ width: { xs: '73%', sm: '61%' } }}>
              We couldn’t load the app. Please check your connection and try again.
            </Typography>
            <Button onClick={() => window.location.reload()} variant="contained">
              Refresh Page
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}

export default ErrorState;
